module.exports = __webpack_public_path__ + "img/arrow-left.70837bc9.svg";